import { byId, formatTime } from '../dom.ts';
import { state, subscribe } from '../state.ts';
import {
  markInHere,
  markOutHere,
  pause,
  resetMarks,
  setFrame,
  setMarkIn,
  setMarkOut,
  stepFrame,
  toggle,
} from '../timeline.ts';

export function initTransport(): void {
  const transport = byId<HTMLDivElement>('transport');
  const scrubber = byId<HTMLInputElement>('scrubber');
  const markRange = byId<HTMLDivElement>('mark-range');
  const frameInput = byId<HTMLInputElement>('frame-input');
  const frameTotal = byId<HTMLSpanElement>('frame-total');
  const timeReadout = byId<HTMLSpanElement>('time-readout');
  const playBtn = byId<HTMLButtonElement>('t-play');
  const markInVal = byId<HTMLInputElement>('mark-in-val');
  const markOutVal = byId<HTMLInputElement>('mark-out-val');
  const rangeInfo = byId<HTMLSpanElement>('range-info');

  scrubber.addEventListener('input', () => {
    pause();
    setFrame(Number(scrubber.value));
  });
  frameInput.addEventListener('change', () => {
    pause();
    setFrame(Number(frameInput.value));
  });

  byId('t-play').addEventListener('click', toggle);
  byId('t-back').addEventListener('click', () => stepFrame(-1));
  byId('t-fwd').addEventListener('click', () => stepFrame(1));
  byId('t-start').addEventListener('click', () => {
    pause();
    setFrame(state.markIn);
  });
  byId('t-end').addEventListener('click', () => {
    pause();
    setFrame(state.markOut);
  });

  byId('mark-in-btn').addEventListener('click', markInHere);
  byId('mark-out-btn').addEventListener('click', markOutHere);
  byId('mark-reset').addEventListener('click', resetMarks);
  markInVal.addEventListener('change', () => setMarkIn(Number(markInVal.value)));
  markOutVal.addEventListener('change', () => setMarkOut(Number(markOutVal.value)));

  window.addEventListener('keydown', (e) => {
    const t = e.target as HTMLElement | null;
    if (t instanceof HTMLInputElement || t instanceof HTMLSelectElement || t instanceof HTMLTextAreaElement) {
      return;
    }
    if (!state.clips.length) return;
    const step = e.shiftKey ? 10 : 1;
    switch (e.key) {
      case ' ':
        e.preventDefault();
        toggle();
        break;
      case 'ArrowLeft':
        e.preventDefault();
        stepFrame(-step);
        break;
      case 'ArrowRight':
        e.preventDefault();
        stepFrame(step);
        break;
      case 'i':
      case 'I':
        markInHere();
        break;
      case 'o':
      case 'O':
        markOutHere();
        break;
      case 'Home':
        e.preventDefault();
        pause();
        setFrame(state.markIn);
        break;
      case 'End':
        e.preventDefault();
        pause();
        setFrame(state.markOut);
        break;
      case 'k':
      case 'K':
        toggle();
        break;
      case 'j':
      case 'J':
        stepFrame(-step);
        break;
      case 'l':
      case 'L':
        stepFrame(step);
        break;
    }
  });

  subscribe(() => {
    transport.hidden = state.clips.length === 0;
    if (transport.hidden) return;

    const last = Math.max(0, state.totalFrames - 1);
    scrubber.max = String(last);
    if (document.activeElement !== scrubber) scrubber.value = String(state.frame);
    if (document.activeElement !== frameInput) frameInput.value = String(state.frame);
    frameTotal.textContent = `/ ${last}`;
    timeReadout.textContent = `${formatTime(state.frame / state.fps)} / ${formatTime(
      state.totalFrames / state.fps
    )} · ${state.fps}fps`;
    playBtn.textContent = state.playing ? 'Pause' : 'Play';

    if (document.activeElement !== markInVal) markInVal.value = String(state.markIn);
    if (document.activeElement !== markOutVal) markOutVal.value = String(state.markOut);
    const frames = state.markOut - state.markIn + 1;
    rangeInfo.textContent = `${frames} frames · ${formatTime(frames / state.fps)}`;

    const denom = Math.max(1, last);
    markRange.style.left = `${(state.markIn / denom) * 100}%`;
    markRange.style.width = `${((state.markOut - state.markIn) / denom) * 100}%`;
  });
}
